import { Component } from '@angular/core';

@Component({
    selector: 'pdf-password-dialog',
    templateUrl: './pdf-password-dialog.component.html',
    standalone: false
})
export class PdfPasswordDialogComponent {}
